<template>
    <transition name="down-transform">
        <div class="back-top" @click="backTop">
            <i class="el-icon-arrow-up"></i>
        </div>
    </transition>
</template>

<script type="text/ecmascript-6">
    export default {
      data () {
        return {

        }
      },
      methods: {
        backTop() {
        }
      },
      components: {

      }
    }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
    @import '~common/stylus/variable.styl'

    .back-top
      position fixed
      z-index 9999
      bottom 50px
      right 50px
      width 50px
      height 50px
      border-radius 50%
      background-color $color-theme
      color #fff
      display flex
      justify-content center
      align-items center
      font-size 20px
      transition all .3s
</style>
